import { Validator } from "./validator";
import * as _m0 from "protobufjs/minimal";
import { Long } from "@osmonauts/helpers";
function createBaseHostZone() {
  return {
    chainId: "",
    bech32prefix: "",
    connectionId: "",
    transferChannelId: "",
    ibcDenom: "",
    hostDenom: "",
    unbondingPeriod: Long.UZERO,
    validators: [],
    depositAddress: "",
    withdrawalIcaAddress: "",
    feeIcaAddress: "",
    delegationIcaAddress: "",
    redemptionIcaAddress: "",
    totalDelegations: "",
    lastRedemptionRate: "",
    redemptionRate: "",
    minRedemptionRate: "",
    maxRedemptionRate: "",
    lsmLiquidStakeEnabled: false,
    halted: false
  };
}
export const HostZone = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.chainId !== "") {
      writer.uint32(10).string(message.chainId);
    }
    if (message.bech32prefix !== "") {
      writer.uint32(138).string(message.bech32prefix);
    }
    if (message.connectionId !== "") {
      writer.uint32(18).string(message.connectionId);
    }
    if (message.transferChannelId !== "") {
      writer.uint32(98).string(message.transferChannelId);
    }
    if (message.ibcDenom !== "") {
      writer.uint32(66).string(message.ibcDenom);
    }
    if (message.hostDenom !== "") {
      writer.uint32(74).string(message.hostDenom);
    }
    if (!message.unbondingPeriod.isZero()) {
      writer.uint32(208).uint64(message.unbondingPeriod);
    }
    for (const v of message.validators) {
      Validator.encode(v, writer.uint32(26).fork()).ldelim();
    }
    if (message.depositAddress !== "") {
      writer.uint32(146).string(message.depositAddress);
    }
    if (message.withdrawalIcaAddress !== "") {
      writer.uint32(178).string(message.withdrawalIcaAddress);
    }
    if (message.feeIcaAddress !== "") {
      writer.uint32(186).string(message.feeIcaAddress);
    }
    if (message.delegationIcaAddress !== "") {
      writer.uint32(194).string(message.delegationIcaAddress);
    }
    if (message.redemptionIcaAddress !== "") {
      writer.uint32(202).string(message.redemptionIcaAddress);
    }
    if (message.totalDelegations !== "") {
      writer.uint32(106).string(message.totalDelegations);
    }
    if (message.lastRedemptionRate !== "") {
      writer.uint32(82).string(message.lastRedemptionRate);
    }
    if (message.redemptionRate !== "") {
      writer.uint32(90).string(message.redemptionRate);
    }
    if (message.minRedemptionRate !== "") {
      writer.uint32(162).string(message.minRedemptionRate);
    }
    if (message.maxRedemptionRate !== "") {
      writer.uint32(170).string(message.maxRedemptionRate);
    }
    if (message.lsmLiquidStakeEnabled === true) {
      writer.uint32(216).bool(message.lsmLiquidStakeEnabled);
    }
    if (message.halted === true) {
      writer.uint32(152).bool(message.halted);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHostZone();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.chainId = reader.string();
          break;
        case 17:
          message.bech32prefix = reader.string();
          break;
        case 2:
          message.connectionId = reader.string();
          break;
        case 12:
          message.transferChannelId = reader.string();
          break;
        case 8:
          message.ibcDenom = reader.string();
          break;
        case 9:
          message.hostDenom = reader.string();
          break;
        case 26:
          message.unbondingPeriod = reader.uint64();
          break;
        case 3:
          message.validators.push(Validator.decode(reader, reader.uint32()));
          break;
        case 18:
          message.depositAddress = reader.string();
          break;
        case 22:
          message.withdrawalIcaAddress = reader.string();
          break;
        case 23:
          message.feeIcaAddress = reader.string();
          break;
        case 24:
          message.delegationIcaAddress = reader.string();
          break;
        case 25:
          message.redemptionIcaAddress = reader.string();
          break;
        case 13:
          message.totalDelegations = reader.string();
          break;
        case 10:
          message.lastRedemptionRate = reader.string();
          break;
        case 11:
          message.redemptionRate = reader.string();
          break;
        case 20:
          message.minRedemptionRate = reader.string();
          break;
        case 21:
          message.maxRedemptionRate = reader.string();
          break;
        case 27:
          message.lsmLiquidStakeEnabled = reader.bool();
          break;
        case 19:
          message.halted = reader.bool();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$chainId, _object$bech32prefix, _object$connectionId, _object$transferChann, _object$ibcDenom, _object$hostDenom, _object$validators, _object$depositAddres, _object$withdrawalIca, _object$feeIcaAddress, _object$delegationIca, _object$redemptionIca, _object$totalDelegati, _object$lastRedemptio, _object$redemptionRat, _object$minRedemption, _object$maxRedemption, _object$lsmLiquidStak, _object$halted;
    const message = createBaseHostZone();
    message.chainId = (_object$chainId = object.chainId) !== null && _object$chainId !== void 0 ? _object$chainId : "";
    message.bech32prefix = (_object$bech32prefix = object.bech32prefix) !== null && _object$bech32prefix !== void 0 ? _object$bech32prefix : "";
    message.connectionId = (_object$connectionId = object.connectionId) !== null && _object$connectionId !== void 0 ? _object$connectionId : "";
    message.transferChannelId = (_object$transferChann = object.transferChannelId) !== null && _object$transferChann !== void 0 ? _object$transferChann : "";
    message.ibcDenom = (_object$ibcDenom = object.ibcDenom) !== null && _object$ibcDenom !== void 0 ? _object$ibcDenom : "";
    message.hostDenom = (_object$hostDenom = object.hostDenom) !== null && _object$hostDenom !== void 0 ? _object$hostDenom : "";
    message.unbondingPeriod = object.unbondingPeriod !== undefined && object.unbondingPeriod !== null ? Long.fromValue(object.unbondingPeriod) : Long.UZERO;
    message.validators = ((_object$validators = object.validators) === null || _object$validators === void 0 ? void 0 : _object$validators.map(e => Validator.fromPartial(e))) || [];
    message.depositAddress = (_object$depositAddres = object.depositAddress) !== null && _object$depositAddres !== void 0 ? _object$depositAddres : "";
    message.withdrawalIcaAddress = (_object$withdrawalIca = object.withdrawalIcaAddress) !== null && _object$withdrawalIca !== void 0 ? _object$withdrawalIca : "";
    message.feeIcaAddress = (_object$feeIcaAddress = object.feeIcaAddress) !== null && _object$feeIcaAddress !== void 0 ? _object$feeIcaAddress : "";
    message.delegationIcaAddress = (_object$delegationIca = object.delegationIcaAddress) !== null && _object$delegationIca !== void 0 ? _object$delegationIca : "";
    message.redemptionIcaAddress = (_object$redemptionIca = object.redemptionIcaAddress) !== null && _object$redemptionIca !== void 0 ? _object$redemptionIca : "";
    message.totalDelegations = (_object$totalDelegati = object.totalDelegations) !== null && _object$totalDelegati !== void 0 ? _object$totalDelegati : "";
    message.lastRedemptionRate = (_object$lastRedemptio = object.lastRedemptionRate) !== null && _object$lastRedemptio !== void 0 ? _object$lastRedemptio : "";
    message.redemptionRate = (_object$redemptionRat = object.redemptionRate) !== null && _object$redemptionRat !== void 0 ? _object$redemptionRat : "";
    message.minRedemptionRate = (_object$minRedemption = object.minRedemptionRate) !== null && _object$minRedemption !== void 0 ? _object$minRedemption : "";
    message.maxRedemptionRate = (_object$maxRedemption = object.maxRedemptionRate) !== null && _object$maxRedemption !== void 0 ? _object$maxRedemption : "";
    message.lsmLiquidStakeEnabled = (_object$lsmLiquidStak = object.lsmLiquidStakeEnabled) !== null && _object$lsmLiquidStak !== void 0 ? _object$lsmLiquidStak : false;
    message.halted = (_object$halted = object.halted) !== null && _object$halted !== void 0 ? _object$halted : false;
    return message;
  }
};